import localforage from "localforage";

// Create different stores for modular design
export const salesDb = localforage.createInstance({
  name: "SuperPOS",
  storeName: "sales",
});

export const productsDb = localforage.createInstance({
  name: "SuperPOS",
  storeName: "products",
});
